module.exports = __webpack_public_path__ + "static/img/XavierCooks.afc4f3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XavierCooks.jpg
// module id = +bIU
// module chunks = 0